// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dd397769","244":"e600f6a0","453":"6074dbb1"}[chunkId] + ".chunk.js";
};